import { action, observable, runInAction } from 'mobx';
import { PasswordStore } from 'ui/base/input';
import { IAccountsDomain } from 'services/accounts/types';
import * as UserService from 'services/accounts/user_service';
import { ResultKind } from 'services/base/types';
import { BusyStore } from 'ui/base/button';

export class DeleteAccountStore {
  readonly password: PasswordStore;

  @observable.ref
  passwordError: string | undefined;

  @observable.ref
  busy: BusyStore;

  constructor() {
    this.password = new PasswordStore('');
    this.busy = new BusyStore();
  }

  @action.bound
  async handleSave(domain: IAccountsDomain): Promise<UserService.DeleteUserResult> {
    this.passwordError = undefined;

    const result = await UserService.deleteUser({
      domain,
      password: this.password.value,
    });
    return runInAction(() => {
      if (result.kind === ResultKind.USER_ERROR) {
        this.passwordError = result.passwordError;
      }
      return result;
    });
  }
}